var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM15 26.6624C8.55901 26.6624 3.33756 21.441 3.33756 15C3.33756 8.55901 8.55901 3.33756 15 3.33756C21.441 3.33756 26.6624 8.55901 26.6624 15C26.6624 21.441 21.441 26.6624 15 26.6624ZM11.0608 21.5607L15.2501 17.3713L19.4395 21.5607L21.5608 19.4393L17.3714 15.25L21.5608 11.0607L19.4395 8.93933L15.2501 13.1287L11.0608 8.93933L8.93945 11.0607L13.1288 15.25L8.93945 19.4393L11.0608 21.5607Z",
    fill: "#FF4040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.e6599b8eba4c68ce61d4ed21c684fe6b.svg";
export { ForwardRef as ReactComponent };